module.exports = __webpack_public_path__ + "img/dateicon.4f77fdd4.svg";